__turbopack_context__.v({
  "photo_gallery": "_5u_N8q_photo_gallery",
  "photo_gallery__caption_text": "_5u_N8q_photo_gallery__caption_text",
  "photo_gallery__container": "_5u_N8q_photo_gallery__container",
  "photo_gallery__figcaption_container": "_5u_N8q_photo_gallery__figcaption_container",
  "photo_gallery__figcaption_credit_text": "_5u_N8q_photo_gallery__figcaption_credit_text",
  "photo_gallery__figcaption_pagination": "_5u_N8q_photo_gallery__figcaption_pagination",
  "photo_gallery__figure": "_5u_N8q_photo_gallery__figure",
  "photo_gallery__photos": "_5u_N8q_photo_gallery__photos",
  "photo_gallery__splide_arrow": "_5u_N8q_photo_gallery__splide_arrow",
  "splide__arrow": "_5u_N8q_splide__arrow",
  "splide__list": "_5u_N8q_splide__list",
  "splide__slide": "_5u_N8q_splide__slide",
});
